"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _styles = require("@material-ui/core/styles");

var _colors = require("../../theme/colors");

var _themeProvider = _interopRequireDefault(require("../../theme/theme-provider"));

var _Control = _interopRequireDefault(require("./shared/Control"));

var _ClearIndicator = _interopRequireDefault(require("./shared/ClearIndicator"));

var _DropdownIndicator = _interopRequireDefault(require("./shared/DropdownIndicator"));

var _Group = _interopRequireDefault(require("./shared/Group"));

var _GroupHeading = _interopRequireDefault(require("./shared/GroupHeading"));

var _IndicatorSeparator = _interopRequireDefault(require("./shared/IndicatorSeparator"));

var _Menu = _interopRequireDefault(require("./shared/Menu"));

var _VirtualMenuList = _interopRequireDefault(require("./shared/VirtualMenuList"));

var _MultiValue = _interopRequireDefault(require("./shared/MultiValue"));

var _NoOptionMessage = _interopRequireDefault(require("./shared/NoOptionMessage"));

var _Option = _interopRequireDefault(require("./shared/Option"));

var _Placeholder = _interopRequireDefault(require("./shared/Placeholder"));

var _SingleValue = _interopRequireDefault(require("./shared/SingleValue"));

var _ValueContainer = _interopRequireDefault(require("./shared/ValueContainer")); // component overrides


var styles = function styles(theme) {
  return {
    chipWrapper: {
      padding: theme.spacing.unit * (1 / 4)
    },
    disabled: {},
    divider: {
      margin: 0
    },
    dropdownIndicatorHover: {
      color: theme.palette.text.primary
    },
    dropdownIndicatorRoot: {
      color: theme.palette.text.secondary
    },
    error: {},
    focused: {},
    indicatorSeparator: {
      display: 'none'
    },
    input: {
      '&$disabled': {
        background: _colors.opacity.black[8]
      },
      '&:hover:not($disabled):not($focused):not($error)': {
        background: _colors.opacity.black[8]
      },
      borderRadius: '2px 2px 0 0',
      display: 'flex',
      height: 36,
      minWidth: 280,
      padding: 0,
      paddingLeft: 16
    },
    inputComponent: {
      backgroundColor: _colors.opacity.black[4],
      'label + &': {
        marginTop: 20
      },
      marginBottom: 4
    },
    inputLabel: (0, _objectSpread2["default"])({}, theme.typography.overline, {
      '&$error': {
        color: theme.palette.error.dark
      },
      color: theme.palette.text.secondary
    }),
    inputUnderlined: {
      '&$disabled:before': {
        borderBottom: 'none'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.dark
      }
    },
    multiSelectCheckbox: {
      marginLeft: theme.spacing.unit * -1,
      marginRight: theme.spacing.unit
    },
    option: {
      '&$disabled': {
        color: theme.palette.text.disabled,
        fontWeight: 400
      },
      '&$focused': {
        fontWeight: 400
      },
      '&$selected': {
        background: 'none',
        fontWeight: 400
      },
      '&$selected:hover': {
        background: 'none'
      },
      '&:hover': {
        background: 'none'
      },
      color: theme.palette.text.primary,
      fontWeight: 400,
      paddingLeft: 5
    },
    paper: {
      borderRadius: '0 0 2px 2px',
      boxShadow: theme.shadows[4],
      minWidth: 280,
      paddingBottom: 4,
      paddingTop: 4
    },
    placeholder: {
      color: theme.palette.text.hint,
      left: 16,
      position: 'absolute'
    },
    selected: {},
    singleValue: {
      color: theme.palette.text.primary,
      left: 16,
      position: 'absolute'
    },
    valueContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      overflow: 'hidden'
    }
  };
};

var noOptionsMessage = function noOptionsMessage() {
  return 'No results found.';
}; // {/* {({ index, style }) => <div style={style}>{children[index]}</div>}


var componentOverrides = function componentOverrides() {
  return {
    ClearIndicator: _ClearIndicator["default"],
    Control: _Control["default"],
    DropdownIndicator: _DropdownIndicator["default"],
    Group: _Group["default"],
    GroupHeading: _GroupHeading["default"],
    IndicatorSeparator: _IndicatorSeparator["default"],
    Menu: _Menu["default"],
    MultiValue: _MultiValue["default"],
    NoOptionsMessage: _NoOptionMessage["default"],
    Option: _Option["default"],
    Placeholder: _Placeholder["default"],
    SingleValue: _SingleValue["default"],
    ValueContainer: _ValueContainer["default"]
  };
};

function optionBackground(isDisabled, isSelected, isFocused, isMulti) {
  if (isDisabled) {
    return _themeProvider["default"].palette.text.disabled;
  }

  if (isFocused) {
    return _colors.opacity.black[8];
  }

  if (isSelected) {
    if (isMulti) {
      return null;
    }

    return _colors.opacity.primary[500][14];
  }

  return null;
}

var customStyles = {
  clearIndicator: function clearIndicator() {
    return {
      cursor: 'pointer',
      display: 'flex',
      paddingBottom: 8,
      paddingLeft: 8,
      paddingRight: 0,
      paddingTop: 8
    };
  },
  input: function input(provided) {
    return (0, _objectSpread2["default"])({}, provided, {
      margin: 0
    });
  },
  menu: function menu(provided) {
    return (0, _objectSpread2["default"])({}, provided, {
      marginTop: 0
    });
  },
  option: function option(provided, _ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected,
        isMulti = _ref.isMulti;
    return (0, _objectSpread2["default"])({}, provided, {
      ':active': {
        backgroundColor: isMulti ? null : _colors.opacity.primary[500][14]
      },
      backgroundColor: optionBackground(isDisabled, isSelected, isFocused, isMulti),
      height: 32,
      padding: '0px 11px'
    });
  }
};

var Select =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Select, _React$Component);

  function Select() {
    (0, _classCallCheck2["default"])(this, Select);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Select).apply(this, arguments));
  }

  (0, _createClass2["default"])(Select, [{
    key: "getLibraryComponent",
    value: function getLibraryComponent(isCreatable) {
      return isCreatable ? _reactSelect.Creatable : _reactSelect["default"];
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
          classes = _this$props.classes,
          label = _this$props.label,
          helperText = _this$props.helperText,
          error = _this$props.error,
          isCreatable = _this$props.isCreatable,
          isMulti = _this$props.isMulti,
          maxLength = _this$props.maxLength,
          renderVirtual = _this$props.renderVirtual,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["classes", "label", "helperText", "error", "isCreatable", "isMulti", "maxLength", "renderVirtual"]);
      var SelectComponent = this.getLibraryComponent(isCreatable);
      var overrides = componentOverrides();

      if (renderVirtual === true) {
        overrides.MenuList = _VirtualMenuList["default"];
      }

      if (maxLength > 1) {
        overrides.Input = function (props) {
          return _react["default"].createElement(_reactSelect.components.Input, (0, _extends2["default"])({
            maxLength: maxLength
          }, props));
        };
      }

      return _react["default"].createElement(SelectComponent, (0, _extends2["default"])({}, rest, {
        classes: classes,
        components: overrides,
        hideSelectedOptions: false,
        isMulti: isMulti,
        isMultiWithChips: isMulti,
        menuPlacement: "auto",
        menuPosition: "absolute",
        noOptionsMessage: noOptionsMessage,
        styles: customStyles,
        textFieldProps: {
          error: error,
          helperText: helperText,
          InputLabelProps: {
            classes: {
              error: classes.error,
              root: classes.inputLabel
            },
            error: error,
            shrink: true
          },
          label: label
        },
        theme: function theme(_theme) {
          return (0, _objectSpread2["default"])({}, _theme, {
            colors: (0, _objectSpread2["default"])({}, _theme.colors, {
              primary: _colors.opacity.primary[500][14],
              primary25: _colors.opacity.black[8],
              primary50: _colors.opacity.primary[500][14],
              primary75: _colors.opacity.primary[500][14]
            })
          });
        }
      }));
    }
  }]);
  return Select;
}(_react["default"].Component);

Select.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * If `true`, the select will close when an item is selected.
   */
  closeMenuOnSelect: _propTypes["default"].bool,

  /**
   * If `true`, the select will be in an error state.
   */
  error: _propTypes["default"].bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string,

  /**
   * If `true`, the component will allow the typed value to be created as a new option.
   */
  isCreatable: _propTypes["default"].bool,

  /**
   * If `true`, the select will be disabled.
   */
  isDisabled: _propTypes["default"].bool,

  /**
   * Callback fired when the state is changed.
   */
  onChange: _propTypes["default"].func,

  /**
   * options to be displayed for the options of the select
   */
  options: _propTypes["default"].array,

  /**
   * the ghost text displayed before a value is selected
   */
  placeholder: _propTypes["default"].node,

  /**
   * If `true`, the component will render list options virtually.
   * Useful for large datasets. See [react-window](https://www.npmjs.com/package/react-window).
   */
  renderVirtual: _propTypes["default"].bool,
  theme: _propTypes["default"].object,

  /**
   * The value of the component.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array])
} : {};

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(Select);

exports["default"] = _default;